import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://szkcuuzkbxvgbwrajrmb.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN6a2N1dXprYnh2Z2J3cmFqcm1iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI4OTg1NTIsImV4cCI6MjA4ODQ3NDU1Mn0.dKeM8b4nZFlikH_52TBSyyR4nMH0p2wLG9zyfy93vYU';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
